import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../core/data/redux/store";
import {
  createEsicBenefitType,
  updateEsicBenefitType,
  fetchEsicBenefitTypeList,
  deleteEsicBenefitType,
} from "../../../../core/data/redux/payroll/ESIC/Master/Benefit/benefitAction";
import { Drawer, message } from "antd";
import DeleteModal1 from "../../../../core/modals/deleteModal1";

const EsicBenefitModal: React.FC<any> = ({
  handleCancel,
  isModalVisible,
  modalType,
  selectedRowData,
  benefitData,
  setBenefitData,
  setTableKey,
  setIsDeleteModalVisible,
  isDeleteModalVisible,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector((state: any) => state.esic.benefit);

  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (modalType === "edit" && selectedRowData) {
      setBenefitData({
        benefit_name: selectedRowData.benefit_name || "",
        description: selectedRowData.description || "",
      });
    } else {
      resetForm();
    }
  }, [modalType, selectedRowData]);

  const resetForm = () => {
    setBenefitData({
      benefit_name: "",
      description: "",
    });
    setErrors({});
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    setBenefitData({ ...benefitData, [field]: e.target.value });
    setErrors((prev: any) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors: any = {};
    if (!benefitData.benefit_name)
      newErrors.benefit_name = "Benefit Name is required.";
    if (!benefitData.description)
      newErrors.description = "Description is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      let result;
      if (modalType === "create") {
        result = await dispatch(createEsicBenefitType(benefitData)).unwrap();
      } else if (modalType === "edit" && selectedRowData) {
        result = await dispatch(
          updateEsicBenefitType({ id: selectedRowData.benefit_id, ...benefitData })
        ).unwrap();
      }
      if (result) {
        message.success("Saved successfully");
        await dispatch(fetchEsicBenefitTypeList());
        setTableKey((prev: any) => prev + 1);
        resetForm();
        handleCancel();
      }
    } catch (error: any) {
      message.error(error.error || "An error occurred");
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const result = await dispatch(deleteEsicBenefitType(id));
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Deleted successfully");
        await dispatch(fetchEsicBenefitTypeList());
        setTableKey((prev: any) => prev + 1);
        setIsDeleteModalVisible(false);
      } else {
        message.warning("Delete failed");
      }
    } catch {
      message.error("Something went wrong");
    }
  };

  return (
    <>
      <Drawer
        title={modalType === "edit" ? "Edit ESIC Benefit" : "Add ESIC Benefit"}
        placement="right"
        width={500}
        onClose={() => {
          handleCancel();
          resetForm();
        }}
        open={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          {/* Benefit Name */}
          <div className="mb-3">
            <label className="form-label">
              Benefit Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={benefitData.benefit_name}
              onChange={(e) => handleInputChange(e, "benefit_name")}
            />
            {errors.benefit_name && (
              <div className="text-danger">{errors.benefit_name}</div>
            )}
          </div>

          {/* Description */}
          <div className="mb-3">
            <label className="form-label">
              Description <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              rows={3}
              value={benefitData.description}
              onChange={(e) => handleInputChange(e, "description")}
            />
            {errors.description && (
              <div className="text-danger">{errors.description}</div>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white border me-2"
              onClick={() => {
                resetForm();
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              {modalType === "edit" ? "Update Benefit" : "Add Benefit"}
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.benefit_id && handleDelete(selectedRowData.benefit_id)
        }
      />
    </>
  );
};

export default EsicBenefitModal;
